import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import { LanguageProvider } from "@/context/LanguageContext";
import { Toaster } from "@/components/ui/sonner";
import Layout from "@/components/Layout";
import Home from "@/pages/Home";
import Catalogo from "@/pages/Catalogo";
import ProductDetail from "@/pages/ProductDetail";
import Atletas from "@/pages/Atletas";
import AtletaDetail from "@/pages/AtletaDetail";
import SobreVorna from "@/pages/SobreVorna";
import Contacto from "@/pages/Contacto";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminDashboard from "@/pages/admin/AdminDashboard";

function App() {
  return (
    <div className="App">
      <LanguageProvider>
        <HelmetProvider>
          <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<Home />} />
              <Route path="/catalogo" element={<Catalogo />} />
              <Route path="/producto/:slug" element={<ProductDetail />} />
              <Route path="/atletas" element={<Atletas />} />
              <Route path="/atletas/:fid" element={<AtletaDetail />} />
              <Route path="/sobre-vorna" element={<SobreVorna />} />
              <Route path="/contacto" element={<Contacto />} />
            </Route>
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<AdminDashboard />} />
          </Routes>
          </BrowserRouter>
        </HelmetProvider>
        <Toaster position="bottom-right" theme="dark" />
      </LanguageProvider>
    </div>
  );
}

export default App;
